import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-stochastic-modelling',
  templateUrl: './stochastic-modelling.component.html',
  styleUrls: ['./stochastic-modelling.component.scss']
})
export class StochasticModellingComponent implements OnInit {

  exposition: CardContent = {
    title: 'Stochastic Modelling',
    subtitle: 'Individual-based modelling of infection spead on a network',
    image_source: 'assets/images/Outbreak.jpg',
  };

  constructor() { }

  ngOnInit(): void {
  }

}
